export default "__VITE_ASSET__BLIAbAnn__"